import { TUserType, TUserTypeResponse, adaptUserTypeFromResponse } from './user-type.type';


export type TAccountCard = {
	type?: TUserType;
};

export type TAccountCardResponse = {
	type?: TUserTypeResponse;
};

export function adaptAccountCardFromResponse(data: TAccountCardResponse): TAccountCard {
	const {
		type: typeRaw,
	} = data;

	const type = typeRaw ? adaptUserTypeFromResponse(typeRaw) : undefined;

	return {
		type,
	};
}
